import { Control211 } from "aic";
import { CommentFilterOptionValue, CommentViewContext } from "./interface";
import { useComments } from "./useComments";

export const commentFilterOptions: { value: CommentFilterOptionValue; label: string }[] = [
  { value: "all", label: "All Comments" },
  { value: "resolved", label: "Resolved Comments Only" },
  { value: "open", label: "Open Comments Only" },
];

interface CommentFilterProps {
  activeContext: CommentViewContext;
}

/**
 * Dropdown filter for selecting which comments to display.
 *
 * @param props - Component props.
 * @param props.activeContext - Active comment view context.
 */
export const CommentFilter = ({ activeContext }: CommentFilterProps): React.ReactElement | null => {
  const { commentFilter, setCommentFilter } = useComments(activeContext);

  return !setCommentFilter ? null : (
    <Control211
      id="toc-comment-filter"
      label="Comment filter"
      labelWidth={"auto"}
      value={commentFilter}
      options={commentFilterOptions}
      setValue={(ret: string) => {
        setCommentFilter(ret as CommentFilterOptionValue);
      }}
    />
  );
};

CommentFilter.displayName = "CommentFilter";
